module.exports = __webpack_public_path__ + "static/quiz_mhnn_mangertgr-b16c3b1b737a04ea4d6fc32e0e178a5a.png";